module.exports = __webpack_public_path__ + "img/results2.92fd8d41.svg";